import React from 'react';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
};

export default function Pagination({
  currentPage,
  totalPages,
  onChange,
}: PaginationProps) {
  return (
    <div className="d-flex justify-content-center py-3 border-top bg-white">
      <UltimatePagination
        currentPage={currentPage}
        totalPages={totalPages}
        onChange={onChange}
      />
    </div>
  );
}

